import { useState } from "react";
import { useFormContext } from "react-hook-form";

import type { ButtonProps } from "@luna-restaurant/ui";
import { Button, useCustomTheme } from "@luna-restaurant/ui";

export function ResetButton({
  title,
  buttonStyle,
  iconColor,
  onHoverIn,
  onHoverOut,
  disabled,
  ...rest
}: { title: string } & Omit<ButtonProps, "buttonText" | "onPress">) {
  const { reset } = useFormContext();
  const { colors } = useCustomTheme();
  const [isHovered, setIsHovered] = useState(false);

  const hoverColor = colors.palette.spinach50;
  const activeIconColor = isHovered && !disabled ? hoverColor : iconColor;
  const activeButtonStyle =
    isHovered && !disabled
      ? [buttonStyle, { borderColor: hoverColor }]
      : buttonStyle;

  return (
    <Button
      buttonText={title}
      onPress={() => reset()}
      buttonStyle={activeButtonStyle}
      iconColor={activeIconColor}
      onHoverIn={() => {
        setIsHovered(true);
        onHoverIn?.();
      }}
      onHoverOut={() => {
        setIsHovered(false);
        onHoverOut?.();
      }}
      disabled={disabled}
      {...rest}
    />
  );
}
